import AxiosClient from "../../../services/axios.services";

class CriteriaServices {
  getCriterion = (params) =>
    AxiosClient.get(
      "/api/app/carrera_sucesion_criterios/",
      {
        headers: { "Content-Type": "application/json" },
        params: params,
      }
    );

  getCriterionByID = (id) =>
    AxiosClient.get(
      `/api/app/carrera_sucesion_criterios/${id}/`,
      {
        headers: { "Content-Type": "application/json" },
      }
    );

  saveCriterion = (data) =>
    AxiosClient.post(
      "/api/app/carrera_sucesion_criterios/",
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );

  editCriterion = (id, data) =>
    AxiosClient.put(
      `/api/app/carrera_sucesion_criterios/${id}/`,
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );

  deleteCriterion = (id) =>
    AxiosClient.delete(
      `/api/app/carrera_sucesion_criterios/${id}/`,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
}

export default new CriteriaServices();
